import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IOrderCandidateResponse} from '../interfaces/services/candidate-order-detail-response.interface';

export const getSalesmanCandidateOrder = async (
  id: string,
  token: string,
): Promise<IOrderCandidateResponse> => {
  const remoteURI = remote.getCandidateOrderUri(id);

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;
          const {payload} = data;
          return {
            success,
            payload,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IOrderCandidateResponse;
};
